module.exports = __webpack_public_path__ + "static/media/ADA.3bde3be6.svg";